var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListTask2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.971,
    height: 21.82,
    viewBox: "0 0 22.971 21.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list-task",
    transform: "translate(-1.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2507",
    "data-name": "Trazado 2507",
    d: "M2.591,2.5A1.091,1.091,0,0,0,1.5,3.591V5.773A1.091,1.091,0,0,0,2.591,6.864H4.773A1.091,1.091,0,0,0,5.864,5.773V3.591A1.091,1.091,0,0,0,4.773,2.5ZM4.773,3.591H2.591V5.773H4.773Z",
    transform: "translate(0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2508",
    "data-name": "Trazado 2508",
    d: "M5,4.091A1.052,1.052,0,0,1,6.007,3H20.327a1.052,1.052,0,0,1,1.007,1.091,1.052,1.052,0,0,1-1.007,1.091H6.007A1.052,1.052,0,0,1,5,4.091Zm1.007,7.637a1.094,1.094,0,0,0,0,2.182H20.327a1.094,1.094,0,0,0,0-2.182Zm0,8.728a1.094,1.094,0,0,0,0,2.182H20.327a1.094,1.094,0,0,0,0-2.182Z",
    transform: "translate(3.137 0.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2509",
    "data-name": "Trazado 2509",
    d: "M1.5,7.591A1.091,1.091,0,0,1,2.591,6.5H4.773A1.091,1.091,0,0,1,5.864,7.591V9.773a1.091,1.091,0,0,1-1.091,1.091H2.591A1.091,1.091,0,0,1,1.5,9.773Zm1.091,0H4.773V9.773H2.591Zm0,7.637A1.091,1.091,0,0,0,1.5,16.319V18.5a1.091,1.091,0,0,0,1.091,1.091H4.773A1.091,1.091,0,0,0,5.864,18.5V16.319a1.091,1.091,0,0,0-1.091-1.091Zm2.182,1.091H2.591V18.5H4.773Z",
    transform: "translate(0 4.728)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListTask2);
export default __webpack_public_path__ + "static/media/list-task2.90544b7cc4f478aa08d13ed87fb236fd.svg";
export { ForwardRef as ReactComponent };